import { formatDate } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Input, LOCALE_ID } from '@angular/core';
import { InfoBlockInput } from '@modules/general-rx-data/models/info-block-inputs-model';
import { ScannerInfo } from '@modules/orders-details/models/scanner-info';
import { IdName } from '@shared/models/id-name';
import { Procedure } from '@shared/models/procedure';
import { RxConfiguration } from '@shared/models/rx-configuration';
import { RxModel } from '@shared/models/rx-models/interfaces/rx-model';

@Component({
	selector: 'rx-general-order-info-v1',
	templateUrl: './general-order-info-v1.component.html',
	styleUrls: ['./general-order-info-v1.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class GeneralOrderInfoV1Component {
	@Input() rx: RxModel;
	@Input() rxConfig: RxConfiguration;
	@Input() dateFormat: string;
	@Input() isResponsive = true;
	@Input() isRxForModelingContext = false;
	@Input() isDueDateVisible = true;
	@Input() scannerInfo?: ScannerInfo;

	constructor(@Inject(LOCALE_ID) private readonly locale: string) {}

	getFields = (isModelingContext: boolean, rx: RxModel): InfoBlockInput[] => {
		return isModelingContext
			? [
					{ name: 'GeneralRxData.Practice', id: 'general-practice', value: rx?.CompanyName },
					{ name: 'Lab.LabName', id: 'general-lab-name', value: rx?.Order?.ShipToName }
				]
			: [
					{ name: 'GeneralRxData.Practice', id: 'general-practice', value: rx?.CompanyName },
					{ name: 'GeneralRxData.Ship-to-Address', id: 'general-ship-to-address', value: rx?.ShipToAddress }
				];
	};

	getScanAndStatusFields = (isDueDateVisible: boolean, rx: RxModel, dateFormat: string): InfoBlockInput[] => {
		const fields: InfoBlockInput[] = [
			{
				name: 'GeneralRxData.ScanDate',
				id: 'general-scan-date',
				value: this.formatDateValue(rx?.Order?.ScanDate, dateFormat)
			}
		];

		if (isDueDateVisible) {
			fields.push({
				name: 'GeneralRxData.DueDate',
				id: 'general-due-date',
				value: this.formatDateValue(rx?.Order?.DueDate, dateFormat, 'UTC')
			});
		}

		fields.push({ name: 'GeneralRxData.Status', id: 'general-status', value: rx?.Order?.State });

		return fields;
	};

	getProcedureDescription = (procedureId: number, procedures: Procedure[]): string => {
		return procedures?.find(({ Id }) => Id === procedureId)?.Name ?? '';
	};

	getTypeDescription = (typeId: number, types: IdName[]): string => {
		return types?.find(({ Id }) => Id === typeId)?.Name ?? '';
	};

	private formatDateValue(value: string | Date | undefined | null, dateFormat: string, timezone?: string): string | null {
		if (!value || !dateFormat) {
			return null;
		}

		return formatDate(value, dateFormat, this.locale, timezone);
	}
}
